import { QualificationStatus } from "../api/exportMPDashboardCsv/types";

export type StatusFilter = "all" | QualificationStatus;

export interface MPDashboardFilters {
  years: string[];
  trades: string[];
  status: StatusFilter;
}

const YEARS_PARAM = "years";
const TRADES_PARAM = "trades";
const STATUS_PARAM = "status";

const QUALIFICATION_STATUSES: QualificationStatus[] = [
  "recommend",
  "review",
  "low",
];

const parseNumericList = (value: string | null): string[] => {
  if (!value) {
    return [];
  }

  return value.split(",").filter((item) => /^\d+$/.test(item));
};

const parseStatus = (value: string | null): StatusFilter =>
  QUALIFICATION_STATUSES.find((status) => status === value) ?? "all";

export const parseMPDashboardFilters = (
  searchParams: URLSearchParams,
): MPDashboardFilters => ({
  years: parseNumericList(searchParams.get(YEARS_PARAM)),
  trades: parseNumericList(searchParams.get(TRADES_PARAM)),
  status: parseStatus(searchParams.get(STATUS_PARAM)),
});

const setOrDelete = (
  searchParams: URLSearchParams,
  key: string,
  value: string,
): void => {
  if (value) {
    searchParams.set(key, value);
    return;
  }

  searchParams.delete(key);
};

export const applyMPDashboardFilters = (
  searchParams: URLSearchParams,
  filters: MPDashboardFilters,
): URLSearchParams => {
  const nextParams = new URLSearchParams(searchParams);

  setOrDelete(nextParams, YEARS_PARAM, filters.years.join(","));
  setOrDelete(nextParams, TRADES_PARAM, filters.trades.join(","));
  setOrDelete(
    nextParams,
    STATUS_PARAM,
    filters.status === "all" ? "" : filters.status,
  );

  return nextParams;
};